import React, { useState, useEffect } from 'react';
import { Box, TextField, Typography, Button, Modal, Grid } from '@mui/material';
import SearchableDropdown from '../../Common/SearchableDropdown/SearchableDropdown.tsx';
import { TemplateActions } from '../../../../Services/_actions/index.js';
import { useSnackBar } from '../../Common/SnackBar/index.tsx';
import { TemplateFilters, TemplateResponse } from '../../../../interfaces/Template.interface.ts';

const TemplateNode = ({ data }: any) => {
  const { showSnackBar } = useSnackBar();
  const templateActions = TemplateActions();
  
  const [templateList, setTemplateList] = useState<TemplateResponse>({ pages: 0, list: [{}] });
  const [templateFilters, setTemplateFilters] = useState<TemplateFilters>({
    search: '',
    page: 0,
    sortOrder: 'desc',
    sortField: 'created_at',
    category: '',
    botNumber: '',
  });
  
  const [isTemplateloading, setTemplateIsLoading] = useState(false);
  
  const fetchTemplateList = async (filters: TemplateFilters) => {
    setTemplateIsLoading(true);
    try {
      const res = await templateActions.getWhatsappTemplateList(filters);
      setTemplateList(res);
    } catch (error) {
      console.warn('Error fetching template list:', error);
    } finally {
      setTemplateIsLoading(false);
    }
  };
  
  const handleSearchTemplate = (query: string) => {
    fetchTemplateList({ ...templateFilters, search: query, page: 0 });
  };

  const loadMoreTemplates = async () => {
    if (templateFilters?.page < templateList?.pages) {
      setTemplateIsLoading(true);
      let listData = Array.isArray(templateList?.list) ? [...templateList?.list] : [];
      const data = { ...templateFilters, page: templateFilters.page + 1 };
      setTemplateFilters(data);

      try {
        const res = await templateActions.getWhatsappTemplateList(data);
        if (Array.isArray(res?.list)) {
          listData = [...listData, ...res.list];
          setTemplateList({ ...res, list: listData });
        } else {
          console.warn('Received non-array response for Template list');
        }
      } catch (error) {
        console.error('Error loading more templates:', error);
      } finally {
        setTemplateIsLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchTemplateList(templateFilters);
  }, [templateFilters]);

  // Handle template selection and pass selected template body to parent data.onChange
  const handleTemplateChange = (value) => {
    if (value) {
      const templateWithBody = {
        ...value,
        body: value?.body || '', 
      };
      const updatedData = {
        selectedTemplate: templateWithBody,
        templateId: value?.wa_Id, 
      };

     data.onChange(data.id, updatedData);

      // If body is missing in the template, display an error
      if (!templateWithBody.body) {
        data.validationError = 'Body is missing';
      } else {
        data.validationError = ''; // Clear error if body exists
      }
    }
  };

  return (
    <Box>
      {/* Template Dropdown */}
      <SearchableDropdown
        options={templateList?.list || []}
        value={data?.selectedTemplate || null}
        fetchMoreOptions={templateList?.pages > 1 ? loadMoreTemplates : undefined}
        onSearch={handleSearchTemplate}
        onChange={(value) => handleTemplateChange(value)} // Call handleTemplateChange
        loading={isTemplateloading}
        labelKey="name"
        valueKey="wa_Id"
        getOptionLabel={(option) => option?.name || ''}
      />

      {/* Displaying selected template name */}
      {data?.selectedTemplate && (
        <TextField
          label="Template Name"
          value={data?.selectedTemplate?.name || ''}
          variant="outlined"
          size="small"
          fullWidth
          disabled
          sx={{ marginTop: 2 }}
        />
      )}

      {/* Error Display */}
      {data?.selectedTemplate && data.validationError && (
        <Typography variant="body2" color="error" style={{ fontSize: '12px' }}>
          {data?.validationError || ''}
        </Typography>
      )}
    </Box>
  );
};

export default TemplateNode;